import Vue from 'vue'
import Meta from 'vue-meta'
import { createRouter } from './router.js'
import NoSsr from './components/no-ssr.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../src/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_googlegtag_4996bf70 from 'nuxt_plugin_googlegtag_4996bf70' // Source: ./google-gtag.js (mode: 'client')
import nuxt_plugin_gtm_11953d22 from 'nuxt_plugin_gtm_11953d22' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_portalvue_613e38cc from 'nuxt_plugin_portalvue_613e38cc' // Source: ./portal-vue.js (mode: 'all')
import nuxt_plugin_index_55c03355 from 'nuxt_plugin_index_55c03355' // Source: ./firebase/index.js (mode: 'all')
import nuxt_plugin_sentryserver_6cdcaf1d from 'nuxt_plugin_sentryserver_6cdcaf1d' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_07233d95 from 'nuxt_plugin_sentryclient_07233d95' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_polyfill_4001b817 from 'nuxt_plugin_polyfill_4001b817' // Source: ../src/plugins/initializers/polyfill (mode: 'all')
import nuxt_plugin_apiclient_cd0fdcb4 from 'nuxt_plugin_apiclient_cd0fdcb4' // Source: ../src/plugins/initializers/api-client (mode: 'all')
import nuxt_plugin_apiclientv2_5b8e7c03 from 'nuxt_plugin_apiclientv2_5b8e7c03' // Source: ../src/plugins/initializers/api-client-v2 (mode: 'all')
import nuxt_plugin_casapiclient_1f72dac4 from 'nuxt_plugin_casapiclient_1f72dac4' // Source: ../src/plugins/initializers/cas-api-client (mode: 'all')
import nuxt_plugin_vuepropertydecorator_4fae60b2 from 'nuxt_plugin_vuepropertydecorator_4fae60b2' // Source: ../src/plugins/initializers/vue-property-decorator (mode: 'all')
import nuxt_plugin_elementui_91bf7466 from 'nuxt_plugin_elementui_91bf7466' // Source: ../src/plugins/initializers/element-ui (mode: 'all')
import nuxt_plugin_vuejstogglebutton_547d65c1 from 'nuxt_plugin_vuejstogglebutton_547d65c1' // Source: ../src/plugins/initializers/vue-js-toggle-button.js (mode: 'all')
import nuxt_plugin_filters_31257a33 from 'nuxt_plugin_filters_31257a33' // Source: ../src/plugins/initializers/filters (mode: 'all')
import nuxt_plugin_baseapiclient_0daff992 from 'nuxt_plugin_baseapiclient_0daff992' // Source: ../src/plugins/initializers/base-api-client (mode: 'all')
import nuxt_plugin_baseapiclientv2_5d3706d2 from 'nuxt_plugin_baseapiclientv2_5d3706d2' // Source: ../src/plugins/initializers/base-api-client-v2 (mode: 'all')
import nuxt_plugin_veevalidate_09116b96 from 'nuxt_plugin_veevalidate_09116b96' // Source: ../src/plugins/initializers/vee-validate (mode: 'all')
import nuxt_plugin_can_28aa3208 from 'nuxt_plugin_can_28aa3208' // Source: ../src/plugins/initializers/can (mode: 'all')
import nuxt_plugin_pagetransition_5e1bb58b from 'nuxt_plugin_pagetransition_5e1bb58b' // Source: ../src/plugins/initializers/page-transition (mode: 'all')
import nuxt_plugin_gaevent_47ebf8af from 'nuxt_plugin_gaevent_47ebf8af' // Source: ../src/plugins/initializers/ga-event (mode: 'all')
import nuxt_plugin_gatrackingpageview_e99370d0 from 'nuxt_plugin_gatrackingpageview_e99370d0' // Source: ../src/plugins/initializers/ga-tracking-page-view (mode: 'all')
import nuxt_plugin_gatrackingclick_08e7547d from 'nuxt_plugin_gatrackingclick_08e7547d' // Source: ../src/plugins/initializers/ga-tracking-click (mode: 'all')
import nuxt_plugin_datadogbrowserrum_c66626bc from 'nuxt_plugin_datadogbrowserrum_c66626bc' // Source: ../src/plugins/initializers/datadog-browser-rum (mode: 'all')
import nuxt_plugin_constants_cde68cf2 from 'nuxt_plugin_constants_cde68cf2' // Source: ../src/plugins/initializers/constants (mode: 'all')

// Component: <NoSsr>
Vue.component(NoSsr.name, NoSsr)

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>`
Vue.component(Nuxt.name, Nuxt)

// vue-meta configuration
Vue.use(Meta, {
  keyName: 'head', // the component option name that vue-meta looks for meta info on.
  attribute: 'data-n-head', // the attribute name vue-meta adds to the tags it observes
  ssrAttribute: 'data-n-head-ssr', // the attribute name that lets vue-meta know that meta info has already been server-rendered
  tagIDKeyName: 'hid' // the property name that vue-meta uses to determine whether to overwrite or append a tag
})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    router,
    store,
    nuxt: {
      defaultTransition,
      transitions: [ defaultTransition ],
      setTransitions(transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [ transitions ]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },
      err: null,
      dateErr: null,
      error(err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        const nuxt = this.nuxt || this.$options.nuxt
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) ssrContext.nuxt.error = err
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    store,
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  const inject = function (key, value) {
    if (!key) throw new Error('inject(key, value) has no key provided')
    if (typeof value === 'undefined') throw new Error('inject(key, value) has no value provided')
    key = '$' + key
    // Add into app
    app[key] = value

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) return
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Vue.prototype.hasOwnProperty(key)) {
        Object.defineProperty(Vue.prototype, key, {
          get() {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Plugin execution

  if (process.client && typeof nuxt_plugin_googlegtag_4996bf70 === 'function') {
    await nuxt_plugin_googlegtag_4996bf70(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_11953d22 === 'function') {
    await nuxt_plugin_gtm_11953d22(app.context, inject)
  }

  if (typeof nuxt_plugin_portalvue_613e38cc === 'function') {
    await nuxt_plugin_portalvue_613e38cc(app.context, inject)
  }

  if (typeof nuxt_plugin_index_55c03355 === 'function') {
    await nuxt_plugin_index_55c03355(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_6cdcaf1d === 'function') {
    await nuxt_plugin_sentryserver_6cdcaf1d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_07233d95 === 'function') {
    await nuxt_plugin_sentryclient_07233d95(app.context, inject)
  }

  if (typeof nuxt_plugin_polyfill_4001b817 === 'function') {
    await nuxt_plugin_polyfill_4001b817(app.context, inject)
  }

  if (typeof nuxt_plugin_apiclient_cd0fdcb4 === 'function') {
    await nuxt_plugin_apiclient_cd0fdcb4(app.context, inject)
  }

  if (typeof nuxt_plugin_apiclientv2_5b8e7c03 === 'function') {
    await nuxt_plugin_apiclientv2_5b8e7c03(app.context, inject)
  }

  if (typeof nuxt_plugin_casapiclient_1f72dac4 === 'function') {
    await nuxt_plugin_casapiclient_1f72dac4(app.context, inject)
  }

  if (typeof nuxt_plugin_vuepropertydecorator_4fae60b2 === 'function') {
    await nuxt_plugin_vuepropertydecorator_4fae60b2(app.context, inject)
  }

  if (typeof nuxt_plugin_elementui_91bf7466 === 'function') {
    await nuxt_plugin_elementui_91bf7466(app.context, inject)
  }

  if (typeof nuxt_plugin_vuejstogglebutton_547d65c1 === 'function') {
    await nuxt_plugin_vuejstogglebutton_547d65c1(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_31257a33 === 'function') {
    await nuxt_plugin_filters_31257a33(app.context, inject)
  }

  if (typeof nuxt_plugin_baseapiclient_0daff992 === 'function') {
    await nuxt_plugin_baseapiclient_0daff992(app.context, inject)
  }

  if (typeof nuxt_plugin_baseapiclientv2_5d3706d2 === 'function') {
    await nuxt_plugin_baseapiclientv2_5d3706d2(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_09116b96 === 'function') {
    await nuxt_plugin_veevalidate_09116b96(app.context, inject)
  }

  if (typeof nuxt_plugin_can_28aa3208 === 'function') {
    await nuxt_plugin_can_28aa3208(app.context, inject)
  }

  if (typeof nuxt_plugin_pagetransition_5e1bb58b === 'function') {
    await nuxt_plugin_pagetransition_5e1bb58b(app.context, inject)
  }

  if (typeof nuxt_plugin_gaevent_47ebf8af === 'function') {
    await nuxt_plugin_gaevent_47ebf8af(app.context, inject)
  }

  if (typeof nuxt_plugin_gatrackingpageview_e99370d0 === 'function') {
    await nuxt_plugin_gatrackingpageview_e99370d0(app.context, inject)
  }

  if (typeof nuxt_plugin_gatrackingclick_08e7547d === 'function') {
    await nuxt_plugin_gatrackingclick_08e7547d(app.context, inject)
  }

  if (typeof nuxt_plugin_datadogbrowserrum_c66626bc === 'function') {
    await nuxt_plugin_datadogbrowserrum_c66626bc(app.context, inject)
  }

  if (typeof nuxt_plugin_constants_cde68cf2 === 'function') {
    await nuxt_plugin_constants_cde68cf2(app.context, inject)
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, () => {
        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from, next) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    app,
    store,
    router
  }
}

export { createApp, NuxtError }
